export default __webpack_public_path__ + "static/media/EstateClosureCom-logo.b3f24b2f.png";